import { render, staticRenderFns } from "./set-row.vue?vue&type=template&id=609f83b6"
import script from "./set-row.vue?vue&type=script&lang=js"
export * from "./set-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports